@switch (state()) {
  @case ('incomplete') {
    <button
      type="button"
      class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium bg-amber-100 text-amber-900 hover:bg-amber-200 dark:bg-amber-900 dark:text-amber-100 dark:hover:bg-amber-800"
      cdkOverlayOrigin
      #origin="cdkOverlayOrigin"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-label]="
        'waters.price-lists.completeness.incomplete-aria' | translate: { count: missingCount(), name: priceListName() }
      "
      (mouseenter)="open()"
      (mouseleave)="scheduleClose()"
      (focus)="onFocusIn()"
      (blur)="onFocusOut()"
      (click)="open()">
      <mat-icon class="!w-4 !h-4 !text-base !leading-4">warning</mat-icon>
      {{ 'waters.price-lists.completeness.incomplete-badge' | translate: { count: missingCount() } }}
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayOpen]="isOpen()"
      [cdkConnectedOverlayPositions]="positions"
      (overlayOutsideClick)="close()"
      (detach)="close()">
      <!--
        Keeps itself open while the pointer is on it or the focus is inside it, so its links can be
        reached either way. The pointer leaving only *schedules* a close, which a focused link vetoes —
        otherwise moving the mouse would close the card out from under a keyboard user standing on a link.
      -->
      <div
        class="w-80 max-w-[90vw] rounded-lg border border-gray-200 bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-800"
        (mouseenter)="open()"
        (mouseleave)="scheduleClose()"
        (focusin)="onFocusIn()"
        (focusout)="onFocusOut()">
        <p class="font-medium">
          {{ 'waters.price-lists.completeness.card-title' | translate: { name: priceListName() } }}
        </p>
        <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
          {{
            'waters.price-lists.completeness.card-hint'
              | translate: { missing: missingCount(), expected: expectedCount() }
          }}
        </p>

        <ul class="mt-3 flex flex-col gap-1.5">
          @for (row of gapRows(); track row.key) {
            <li class="flex items-baseline justify-between gap-3 text-sm">
              @if (row.link) {
                <!-- Straight to the grid that is short; the lake-level grids have no link because they
                     are on the page this card is opened from. -->
                <a
                  class="text-primary-700 dark:text-primary-300 hover:underline"
                  [routerLink]="row.link"
                  (click)="close()">
                  {{ row.label }}
                </a>
              } @else {
                <span>{{ row.label }}</span>
              }
              <span class="whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                {{
                  'waters.price-lists.completeness.gap-count'
                    | translate: { missing: row.missingCount, expected: row.expectedCount }
                }}
              </span>
            </li>
          }
        </ul>
      </div>
    </ng-template>
  }
  @case ('complete') {
    <mat-icon
      class="!w-5 !h-5 !text-xl leading-5 text-green-700 dark:text-green-400"
      [matTooltip]="'waters.price-lists.completeness.complete' | translate">
      check_circle
    </mat-icon>
  }
}
